import { useMutation, useQueryClient } from '@tanstack/react-query';

import { AccessFacelessAuditBody } from '@app/domain-access-interfaces';
import { Axios } from '@app/web-components';

import { accessKeys } from './access';

export const useUpsertFacelessAudit = (accessId: number) => {
  const axios = Axios.useAxiosApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: AccessFacelessAuditBody) => axios.put(`/accesses/${accessId}/faceless-audit`, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: accessKeys.item(accessId) });
    },
  });
};
